import AOS from 'aos';
import ModuloBox from './plugins/modulobox.js';
import Masonry from 'masonry-layout';
import CookieNotification from "bb-cookie-notification";
import imagesLoaded from 'imagesloaded';
import Axios from 'axios';
import {Carousel, Dropdown, Collapse} from 'bootstrap';
import Flickity from 'flickity';
import * as FilePond from 'filepond';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginFileEncode from 'filepond-plugin-file-encode';

const initSite = () => {
    // Init Animate On Scroll
    AOS.init();

    // BenedenBoven cookiescript
    new CookieNotification();

    if(document.getElementById('contact-form')) {

        const contactForm = document.getElementById('contact-form');
        contactForm.addEventListener('submit', function(event) {
            event.preventDefault();

            const formData = new FormData(this);
            formData.append('g-recaptcha-response', grecaptcha.getResponse());
            const validationAlert = document.getElementById('contact-form-validation');

            document.querySelectorAll('.invalid-feedback').forEach(element => {
                if(!element.classList.contains('d-none')) {
                    element.classList.add('d-none');
                }
            });

            document.querySelectorAll('.is-invalid').forEach(element => {
                element.classList.remove('is-invalid');
            });

            validationAlert.classList.add('hidden');
            validationAlert.classList.remove('alert-danger');
            Axios.post(contactForm.action, formData).then(response => {
                if(response.data.success) {
                    validationAlert.innerHTML = response.data.message;
                    validationAlert.classList.add('alert-success');
                    validationAlert.classList.remove('hidden');

                    contactForm.innerHTML = '';
                }
            }).catch(exception => {
                grecaptcha.reset();
                if(exception.response.data.errors) {
                    for(let error in exception.response.data.errors) {
                        const el = contactForm.querySelector('[name="' + error + '"]');
                        el.classList.add('is-invalid');
                        if(el.parentNode.querySelector('.d-none') !== null) {
                            el.parentNode.querySelector('.d-none').classList.remove('d-none');
                        }
                    }
                }
            });
        });
    }

    if(document.getElementById('application-form') ) {
        FilePond.registerPlugin(FilePondPluginFileValidateType);
        FilePond.registerPlugin(FilePondPluginFileEncode);
        const filepond = FilePond.create(document.querySelector('.files'), {
            allowMultiple: true,
            instantUpload: false,
            required: true,
            acceptedFileTypes: ['image/png', 'image/jpeg', 'image/jpg', 'application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
            fileValidateTypeLabelExpectedTypesMap: {
                'image/png': '.png',
                'image/jpeg': '.jpg',
                'image/jpg': '.jpg',
                'application/pdf': '.pdf',
                'application/msword': '.doc',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document': '.docx'
            },
            labelFileTypeNotAllowed: 'Onjuist bestandstype!',
            fileValidateTypeLabelExpectedTypes: 'Alleen {allButLastType} en {lastType} zijn togestaan',
            labelIdle: 'Sleep je cv/motivatie hiernaartoe of <span class="filepond--label-action"> blader </span>'
        });

        let currentlySending = false;
        const applicationForm = document.getElementById('application-form');
        applicationForm.addEventListener('submit', (event) => {
            event.preventDefault();

            if(currentlySending === false) {

                currentlySending = true;
                document.querySelector('button[type="submit"]').innerHTML = '<i class="fad fa-circle-notch fa-spin"></i>';
                document.querySelector('button[type="submit"]').disabled = true;

                const formData        = new FormData(applicationForm);
                formData.append('g-recaptcha-response', grecaptcha.getResponse());
                const validationAlert = document.getElementById('application-form-validation');

                document.querySelectorAll('.invalid-feedback').forEach((element) => {
                    if(!element.classList.contains('d-none')) {
                        element.classList.add('d-none');
                    }
                });

                document.querySelectorAll('.is-invalid').forEach((element) => {
                    element.classList.remove('is-invalid');
                });

                validationAlert.classList.add('hidden');
                validationAlert.classList.remove('alert-danger');
                Axios.post(applicationForm.action, formData).then(response => {
                    if(response.data.success) {
                        validationAlert.innerHTML = response.data.message;
                        validationAlert.classList.add('alert-success');
                        validationAlert.classList.remove('hidden');

                        applicationForm.innerHTML = '';
                    } else {
                        currentlySending = false
                        applicationForm.querySelector('button').innerHTML = 'Verstuur';
                        applicationForm.querySelector('button').disabled = false;
                    }
                }).catch(exception => {
                    if(exception.response.data.errors) {
                        for(let error in exception.response.data.errors) {
                            const el = applicationForm.querySelector('[name="' + error + '"]');
                            el.classList.add('is-invalid');
                            if(el.parentNode.querySelector('.d-none') !== null) {
                                el.parentNode.querySelector('.d-none').classList.remove('d-none');
                            }
                        }
                    }
                    currentlySending = false
                    applicationForm.querySelector('button').innerHTML = 'Verstuur';
                    applicationForm.querySelector('button').disabled = false;
                    grecaptcha.reset();
                });
            }
        });
    }

    // Init Flickity
    if(document.querySelector('.main-carousel')) {
        const flkty = new Flickity(document.querySelector('.main-carousel'), {
            cellAlign: 'left',
            contain:   true
        });
    }

    // Smooth scroll
    if(document.querySelector('.js-scroll-trigger')) {
        document.querySelectorAll('.js-scroll-trigger').forEach((link) => {
            link.addEventListener('click', (event) => {
                event.preventDefault();
                const href      = event.currentTarget.getAttribute("href");
                const offsetTop = document.querySelector(href).offsetTop;

                scroll({
                    top:      offsetTop,
                    behavior: "smooth"
                });
            });
        });
    }

    // init Masonry
    if(document.querySelector('.grid')) {
        let grid  = document.querySelector('.grid');
        let msnry = new Masonry(grid, {
            itemSelector:    '.grid-item',
            columnWidth:     '.grid-sizer',
            percentPosition: true
        });

        imagesLoaded(grid).on('progress', () => {
            // layout Masonry after each image loads
            msnry.layout();
        });
    }

    // Add and remove class on scroll
    if(document.querySelector('nav')) {
        let scrollpos      = window.scrollY
        var header         = document.querySelector("nav")
        const headerHeight = header.offsetHeight

        const addClassOnScroll    = () => header.classList.add("navbar-shrink")
        const removeClassOnScroll = () => header.classList.remove("navbar-shrink")

        window.addEventListener('scroll', () => {
            scrollpos = window.scrollY;

            if(scrollpos >= headerHeight) {
                addClassOnScroll()
            } else {
                removeClassOnScroll()
            }
        });
    }

    // Modulobox
    var modulobox = new ModuloBox({
        mediaSelector:      '.gallery figure > a, .hidden-gallery div',
        loop:               3,
        history:            true,
        controls:           ['zoom', 'play', 'fullScreen', 'download', 'share', 'close'],
        shareButtons:       ['facebook', 'googleplus', 'twitter', 'pinterest', 'linkedin', 'reddit', 'stumbleupon', 'tumblr', 'blogger', 'buffer', 'digg', 'evernote'],
        videoMaxWidth:      1440,
        minZoom:            1,
        zoomTo:             1.8,
        mouseWheel:         false,
        contextMenu:        false,
        scrollToZoom:       true,
        captionSmallDevice: false,
        thumbnails:         true,
        thumbnailsNav:      'centered',
        thumbnailSizes:     {
            1920: {
                width:  110,
                height: 80,
                gutter: 10
            },
            1280: {
                width:  90,
                height: 65,
                gutter: 10
            },
            680:  {
                width:  0,
                height: 0,
                gutter: 0
            }
        }
    });

    modulobox.on('beforeOpen.modulobox', (gallery, index) => {
        if(window.cubeRAF) {
            cancelAnimationFrame(window.cubeRAF);
            window.cubeRAF = false;
        }
    });

    modulobox.on('afterClose.modulobox', (gallery, index) => {
        if(typeof Event === 'function' && !window.cubeRAF) {
            window.dispatchEvent(new Event('scroll'));
        }
    });

    modulobox.init();
}

const initRecaptcha = () => {
    const recaptchaElement = document.getElementById('g-recaptcha');
    if(recaptchaElement) {
        grecaptcha.render('g-recaptcha', {
            'sitekey': recaptchaElement.dataset.sitekey
        });
    }
}

window.initRecaptcha = initRecaptcha;

// init Barba
/*barba.use(barbaCss);
barba.init({
    preventRunning: true,
    requestError: (trigger, action, url, response) => {
    },
    transitions: [{
        name:        "boerenvanveen-trans",
        leave:       () => {
        },
        enter:       () => {
        },
        once:        () => {
            // Used for CSS transition (first visit)
        },
        beforeEnter: (data) => {
            initSite();

            if(typeof initAtom !== 'undefined') {
                initAtom();
            }
            initRecaptcha();
            window.scroll({ top: 0, left: 0, behavior: 'smooth' });
        }
    }]
});*/

initSite();
